import { EnumRoutes } from '@/helpers/enums/routes.enum';
import type { RouteRecordRaw } from 'vue-router';

export const authRoutes: Array<RouteRecordRaw> = [
  {
    path: EnumRoutes.auth.root.path,
    name: EnumRoutes.auth.root.name,
    redirect: '/auth/login',
    component: () => import('@/views/auth/experts/AuthLayoutBasicExperts.vue'),
    meta: EnumRoutes.auth.root.meta,
    children: [
      {
        name: EnumRoutes.auth.login.name,
        path: EnumRoutes.auth.login.path,
        component: () => import('@/views/auth/experts/Login.vue'),
        meta: EnumRoutes.auth.login.meta,
      },

      {
        name: EnumRoutes.auth.twoFactorVerification.name,
        path: EnumRoutes.auth.twoFactorVerification.path,
        component: () => import('@/views/auth/experts/VerificationCode.vue'),
        meta: EnumRoutes.auth.twoFactorVerification.meta,
      },
      {
        name: EnumRoutes.auth.forgetPassword.name,
        path: EnumRoutes.auth.forgetPassword.path,
        component: () => import('@/views/auth/experts/ForgetPassword.vue'),
        meta: EnumRoutes.auth.forgetPassword.meta,
      },
      {
        name: EnumRoutes.auth.resetPassword.name,
        path: EnumRoutes.auth.resetPassword.path,
        component: () => import('@/views/auth/experts/ResetPassword.vue'),
        meta: EnumRoutes.auth.resetPassword.meta,
      },
      {
        name: EnumRoutes.auth.verifyEmail.name,
        path: EnumRoutes.auth.verifyEmail.path,
        component: () => import('@/views/auth/experts/VerifyEmail.vue'),
        meta: EnumRoutes.auth.verifyEmail.meta,
      },
      {
        name: EnumRoutes.auth.verifyNumber.name,
        path: EnumRoutes.auth.verifyNumber.path,
        component: () => import('@/views/auth/experts/VerifyNumber.vue'),
        meta: EnumRoutes.auth.verifyNumber.meta,
      },
    ],
  },
  {
    name: EnumRoutes.auth.register.name,
    path: EnumRoutes.auth.register.path,
    component: () =>
      import(
        '@/views/auth/experts/dynamic-register-form/RegisterFormExperts.vue'
      ),
    meta: EnumRoutes.auth.register.meta,
  },
];
